import _ from "lodash";
import React from "react";
import { Divider, Segment, Header, Grid } from "semantic-ui-react";
import "./Form.scss";

interface IPermitsForm {
  sections: any;
}

export const PermitsViewForm = (props: IPermitsForm) => {
  const { sections } = props;

  return (
    <Segment basic className='PermitsForm'>
      {sections?.map((section: any) => (
        <>
          <Grid style={{ marginTop: "16px" }} key={section.name}>
            <Grid.Column computer={6} tablet={8} mobile={16}>
              {section.name && (
                <Header as='h3' style={{ fontWeight: 300 }}>
                  <Header.Content>{section.name}</Header.Content>
                  <Header.Subheader>{section.description}</Header.Subheader>
                </Header>
              )}
            </Grid.Column>
            <Grid.Column computer={10} tablet={16} mobile={16}>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {_.compact(
                  (section?.fields || []).map((field: any) => (
                    <div
                      style={{
                        display: "inline-block",
                        margin: "0 0 32px 10px",
                        flexGrow: 1,
                        minWidth: "calc(100% * (1/2) - 10px - 1px)",
                      }}
                      key={field.name}
                    >
                      <label>{field.name}</label>
                      <p>
                        {field.value?.url ? (
                          <a href={field.value?.signed_url ?? "#"} rel='noopener noreferrer' target='_blank'>
                            {field.value?.name}
                          </a>
                        ) : (
                          field.value
                        )}
                      </p>
                    </div>
                  )),
                )}
              </div>
            </Grid.Column>
          </Grid>
          <Divider />
        </>
      ))}
    </Segment>
  );
};

export default PermitsViewForm;
